import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import { getSemanticColors, SemanticColor } from '../../theme/colors';
import { SuccessAnimationView } from './SuccessAnimationView';

export const SuccessAnimation: React.FC<TWidgetProps<TCommonData>> = ({ widget }) => {
    return (
        <SuccessAnimationView
            uid={widget.uid}
            margin={widget.options?.margin}
            animationsColor={getSemanticColors(widget.version)[SemanticColor.IconEmphasised]}
        />
    );
};
